<form [formGroup]="form">
  <ion-card class="ion-no-padding ion-no-margin">
    <ion-card-content class="ion-no-padding">
      <ion-item lines="full">
        <ion-input label="Name" labelPlacement="floating" formControlName="name" (ionBlur)="updateName()"></ion-input>
      </ion-item>
      <ion-item>
        <ion-input label="Description" labelPlacement="floating" formControlName="descr"
          (ionBlur)="updateDescription()"></ion-input>
      </ion-item>
    </ion-card-content>
  </ion-card>
</form>
